import React from 'react';
import { IoRadioButtonOnOutline, IoRadioButtonOffOutline } from 'react-icons/io5';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import setCategoryPageNrOperation from 'store/category/operation/setCategoryPageNrOperation';
import setCategorySortByOperation from 'store/category/operation/setCategorySortByOperation';
import updateCategoryQueryStringOperation from 'store/category/operation/updateCategoryQueryStringOperation';
import getCategorySortBy from 'store/category/selector/getCategorySortBy';
import { setCategoryRefetchFlagAction } from 'store/category/slice';
import gtmSendEvent, { gtmChangeSortingEvent, gtmSortSelectEvent } from 'utils/gtm/gtmSendEvent';
import styles from './SortBy.module.scss';

const SortBy = () => {
  const history = useHistory();
  const sortBy = useSelector(getCategorySortBy);
  const dispatch = useDispatch();

  const changeSortBy = (sort: number) => {
    gtmSendEvent(gtmChangeSortingEvent(sort));
    gtmSendEvent(gtmSortSelectEvent(sort));
    dispatch(setCategorySortByOperation(sort));
    dispatch(setCategoryPageNrOperation(1));
    dispatch(setCategoryRefetchFlagAction(true));
    dispatch(updateCategoryQueryStringOperation(history));
  };

  const { t } = useTranslation();
  const sortOptions = [
    {
      title: t('txt_sort_by_popular_and_new'),
      value: 6,
    },
    {
      title: t('txt_sort_by_most_popular'),
      value: 1,
    },
    {
      title: t('txt_sort_by_new'),
      value: 2,
    },
  ];

  return (
    <div className={styles.sortBy}>
      <span className={styles.label}>{t('txt_sort_by')}:</span>
      {sortOptions.map((sortOption, index) => (
        <div key={index} onClick={() => changeSortBy(sortOption.value)} className={styles.sortOption}>
          {sortBy === sortOption.value && <IoRadioButtonOnOutline size="18px" />}
          {sortBy !== sortOption.value && <IoRadioButtonOffOutline size="18px" />}
          {sortOption.title}
        </div>
      ))}
    </div>
  );
};

export default SortBy;
